var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_139_3500)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8.5,
    width: 44,
    height: 44,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.75 28.25C35.9489 28.25 36.1397 28.171 36.2803 28.0303C36.421 27.8897 36.5 27.6989 36.5 27.5V26.8805C36.4978 25.8757 36.1056 24.9109 35.4061 24.1895C34.7066 23.4682 33.7543 23.0465 32.75 23.0135V21.5C32.75 21.3011 32.671 21.1103 32.5303 20.9697C32.3897 20.829 32.1989 20.75 32 20.75C31.8011 20.75 31.6103 20.829 31.4697 20.9697C31.329 21.1103 31.25 21.3011 31.25 21.5V23.0135C30.3605 23.0419 29.5078 23.3758 28.8355 23.959C28.1632 24.5422 27.7122 25.3391 27.5584 26.2157C27.4045 27.0923 27.5572 27.9951 27.9908 28.7723C28.4243 29.5496 29.1123 30.1539 29.939 30.4835L33.5037 31.91C34.0169 32.1158 34.4425 32.4938 34.7074 32.9791C34.9723 33.4645 35.0599 34.0269 34.9553 34.5698C34.8507 35.1128 34.5604 35.6023 34.1342 35.9545C33.708 36.3068 33.1724 36.4996 32.6195 36.5H31.3805C30.7493 36.4994 30.1442 36.2484 29.6979 35.8021C29.2516 35.3558 29.0006 34.7507 29 34.1195V33.5C29 33.3011 28.921 33.1103 28.7803 32.9697C28.6397 32.829 28.4489 32.75 28.25 32.75C28.0511 32.75 27.8603 32.829 27.7197 32.9697C27.579 33.1103 27.5 33.3011 27.5 33.5V34.1195C27.5022 35.1243 27.8944 36.0891 28.5939 36.8105C29.2934 37.5318 30.2457 37.9535 31.25 37.9865V39.5C31.25 39.6989 31.329 39.8897 31.4697 40.0303C31.6103 40.171 31.8011 40.25 32 40.25C32.1989 40.25 32.3897 40.171 32.5303 40.0303C32.671 39.8897 32.75 39.6989 32.75 39.5V37.9865C33.6395 37.9581 34.4922 37.6242 35.1645 37.041C35.8368 36.4578 36.2878 35.6609 36.4416 34.7843C36.5955 33.9077 36.4428 33.0049 36.0092 32.2277C35.5757 31.4504 34.8877 30.8461 34.061 30.5165L30.4962 29.09C29.9831 28.8842 29.5575 28.5062 29.2926 28.0209C29.0277 27.5355 28.9401 26.9731 29.0447 26.4302C29.1493 25.8872 29.4396 25.3977 29.8658 25.0455C30.292 24.6932 30.8276 24.5004 31.3805 24.5H32.6195C33.2507 24.5006 33.8558 24.7516 34.3021 25.1979C34.7484 25.6442 34.9994 26.2493 35 26.8805V27.5C35 27.6989 35.079 27.8897 35.2197 28.0303C35.3603 28.171 35.5511 28.25 35.75 28.25Z",
    fill: "#5E72E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_139_3500",
    x: 0,
    y: 0.5,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.552941 0 0 0 0 0.709804 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_3500"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_3500",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollarIcon.ee74a376e8c4fe5fb83be3ce8da82e2f.svg";
export { ForwardRef as ReactComponent };